module.exports = __webpack_public_path__ + "static/page-header-do-1-04e962d2eb3a487e9535a5f9991e612e.png";